import { useMemo, useState } from 'react';
import { twMerge } from 'tailwind-merge';

import { useTranslation } from 'react-i18next';
import { Button } from '@wbk/ui';
import { createCookie } from '@wbk/utils';
import { languages } from '@/i18n/config';
import useLocalization from '@/context/localization/useLocalization';

type Props = {
  className?: string;
  withIcon?: boolean;
  longLang?: boolean;
};

const LanguageSwitch = ({ className, withIcon = true, longLang = false }: Props) => {
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('common');
  const { locale, setLocale } = useLocalization();

  const handleDir = async (goto: string) => {
    try {
      setLoading(true);
      await setLocale(goto);

      createCookie({
        name: 'lang',
        value: goto,
        expiration: 30,
        domain: import.meta.env.VITE_COOKIE_DOMAIN,
      });
    } catch (error) {
      // under investigation if really helpful or not
      // window.location.reload();
    } finally {
      setLoading(false);
    }
  };
  const otherLang = useMemo(() => {
    const lang = languages.filter((l) => l !== locale);
    if (longLang && lang.includes('ar')) {
      return ['ar-SA'];
    }
    return lang;
  }, [locale, longLang]);

  return (
    <Button
      shape='text'
      theme='white'
      className={twMerge('gap-1 py-1 capitalize underline-offset-2 hover:underline', className)}
      onClick={() => handleDir(otherLang[0])}
      data-testid='lang-switcher'
      data-location='header'
      data-target-language={otherLang[0]}
      role='menuitem'
      loading={loading}
    >
      {otherLang[0] === 'en'
        ? withIcon && <img src='/icons/EnglishIcon.svg' alt='' />
        : withIcon && <img src='/icons/ArabicIcon.svg' alt='' />}
      <span
        className={`ltr:font-vazirmatn rtl:font-gellix hidden sm:block ${withIcon && otherLang[0].includes('ar') ? 'relative -top-[3px]' : ''}`}
      >
        {t(`common:${otherLang[0]}`)}
      </span>
      <span
        className={`ltr:font-vazirmatn rtl:font-gellix sm:hidden ${withIcon && otherLang[0].includes('ar') ? 'relative -top-[3px]' : ''}`}
      >
        {t(`common:${otherLang[0]}`)}
      </span>
    </Button>
  );
};

export default LanguageSwitch;
